import QRCodeStyling from 'qr-code-styling';

// Zdieľaná tlač A4 plagátu — rovnaký výstup ako vo WorkplaceQREditor,
// použiteľná aj mimo editora (setup wizard) s uloženým štýlom pracoviska.

const MOBILE_APP_URL = 'https://effzone.sk/mobile-app';

const qrStyleDefaults = { dotColor: '#111827', dotType: 'rounded', logoSize: 0.2, logoMargin: 0 };

const blobToDataUrl = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
});

const parseStyle = (workplace) => {
    try {
        const parsed = JSON.parse(workplace?.qr_style_json || '{}');
        return {
            dotColor: parsed?.dotColor || qrStyleDefaults.dotColor,
            dotType: parsed?.dotType || qrStyleDefaults.dotType,
            logoSize: typeof parsed?.logoSize === 'number' ? parsed.logoSize : qrStyleDefaults.logoSize,
            logoMargin: typeof parsed?.logoMargin === 'number' ? parsed.logoMargin : qrStyleDefaults.logoMargin,
        };
    } catch (e) {
        return { ...qrStyleDefaults };
    }
};

export const buildWorkplaceQrUrl = (workplace) =>
    `${process.env.REACT_APP_QR_BASE_URL || 'https://effzone.com'}/mobile-app/${workplace.qr_code_id}`;

export const printWorkplacePoster = async (workplace) => {
    if (!workplace?.qr_code_id) throw new Error('Missing workplace QR id.');

    const style = parseStyle(workplace);

    // 1) Hlavný QR pracoviska vo vysokej kvalite (uložený štýl alebo default)
    const workplaceQr = new QRCodeStyling({
        width: 1024,
        height: 1024,
        type: 'svg',
        data: buildWorkplaceQrUrl(workplace),
        dotsOptions: { color: style.dotColor, type: style.dotType },
        backgroundOptions: { color: '#FFFFFF' },
        image: workplace.qr_logo_url || undefined,
        imageOptions: { crossOrigin: 'anonymous', margin: style.logoMargin, imageSize: style.logoSize },
    });
    const workplaceQrBlob = await workplaceQr.getRawData('png');
    if (!workplaceQrBlob) throw new Error('Failed to generate QR image.');
    const workplaceQrDataUrl = await blobToDataUrl(workplaceQrBlob);

    // 2) Malý QR na stiahnutie mobilnej appky
    const appQr = new QRCodeStyling({
        width: 512,
        height: 512,
        type: 'svg',
        data: MOBILE_APP_URL,
        dotsOptions: { color: '#111827', type: 'rounded' },
        backgroundOptions: { color: '#FFFFFF' },
    });
    const appQrBlob = await appQr.getRawData('png');
    const appQrDataUrl = appQrBlob ? await blobToDataUrl(appQrBlob) : '';

    const workplaceName = workplace?.name || '';
    const posterHtml = `<!DOCTYPE html>
<html lang="sk">
<head>
<meta charset="UTF-8" />
<title>Effzone – ${workplaceName}</title>
<style>
  @page { size: A4 portrait; margin: 0; }
  * { box-sizing: border-box; margin: 0; padding: 0; }
  html, body { width: 210mm; height: 297mm; }
  body { font-family: Arial, Helvetica, sans-serif; color: #111827; display: flex; flex-direction: column; align-items: center; padding: 18mm 16mm; }
  .brand { font-size: 26px; font-weight: 800; letter-spacing: 0.5px; }
  .workplace { font-size: 20px; font-weight: 600; color: #374151; margin-top: 4mm; }
  .headline { font-size: 30px; font-weight: 800; text-align: center; margin-top: 10mm; }
  .qr { width: 120mm; height: 120mm; margin-top: 8mm; }
  .steps { margin-top: 10mm; font-size: 15px; line-height: 1.9; color: #374151; align-self: center; }
  .steps b { color: #111827; }
  .footer { margin-top: auto; display: flex; align-items: center; gap: 8mm; border-top: 1px solid #e5e7eb; padding-top: 6mm; width: 100%; justify-content: center; }
  .footer .app-qr { width: 28mm; height: 28mm; }
  .footer .hint { font-size: 13px; color: #374151; line-height: 1.6; max-width: 90mm; }
</style>
</head>
<body>
  <div class="brand">Effzone</div>
  ${workplaceName ? `<div class="workplace">${workplaceName}</div>` : ''}
  <div class="headline">Naskenuj a zapíš si dochádzku</div>
  <img class="qr" src="${workplaceQrDataUrl}" alt="QR kód pracoviska" />
  <div class="steps">
    <div><b>1.</b> Stiahni si aplikáciu <b>Effzone</b> (QR kód dole)</div>
    <div><b>2.</b> Naskenuj tento QR kód aplikáciou</div>
    <div><b>3.</b> Prihlás sa svojím telefónnym číslom (príde ti SMS kód)</div>
  </div>
  <div class="footer">
    ${appQrDataUrl ? `<img class="app-qr" src="${appQrDataUrl}" alt="QR na stiahnutie aplikácie" />` : ''}
    <div class="hint">Aplikáciu Effzone stiahneš naskenovaním tohto QR kódu alebo na <b>effzone.sk/mobile-app</b> (App Store aj Google Play).</div>
  </div>
  <script>window.onload = function () { window.focus(); window.print(); };</script>
</body>
</html>`;

    const printWindow = window.open('', '_blank');
    if (!printWindow) throw new Error('Prehliadač zablokoval nové okno. Povoľte pop-up okná.');
    printWindow.document.open();
    printWindow.document.write(posterHtml);
    printWindow.document.close();
};
